import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@codex/basics';
import { formatPrice } from '@codex/helpers';
import AddToBasketButtonWithAjaxCall from '../../../AddToBasket/AddToBasketButtonWithAjaxCall';

const BottomWrapperDiv = styled.div`
  width: 100%;
  max-width: 256px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 204px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 128px;
  }
`;

const PriceBlock = styled.div`
  width: 100%;
  max-width: 256px;
  font-family: Helvetica;
  font-size: 30px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding: 5px 0px 5px 0px;
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    font-size: 22px;
    padding: 4px 0px 5px 0px;
  }
`;

const ViewButton = styled(Button)`
  flex-grow: 1;
  flex-basis: 50%;
  margin-right: 10px;
  padding-left: 9px;
  padding-right: 9px;
  font-family: Helvetica;
    
  @media (max-width: 1239px) { 
    margin-bottom: 10px;
    margin-right: 0px;
  }
  
  @media (max-width: 1024px) { 
    margin-bottom: 0px;
    margin-right: 10px;
  }  
    
  @media ${(props) => props.theme.breakpoints.tablet} {
    width: 98px;
    padding-left: 0px;
    padding-right: 0px;
  }    
    
  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 0px;
  }
`;

const AddToBasketButtonWrapper = styled.div`
  flex-grow: 1;
  flex-basis: 50%;

  button {
    padding-left: 9px;
    padding-right: 9px;
    font-family: Helvetica;
  }
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    width: 98px;
    button {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  
  @media (max-width: 1239px) { 
    display: block;
  }
  
  @media (max-width: 1024px) { 
    display: flex;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: block;
  }
`;

const StyledLabel = styled.span`
  ${(props) => props.isLoading && `
    display: inline-block;
    @media ${props.theme.breakpoints.mobile} {
      display: none;
    }
  `}
`;

const CompareCheckbox = styled.div`
  margin-top: 18px;
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: none;
  }
`;

const WrapperDiv = styled.div`
  margin-bottom: 20px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    margin-bottom: 15px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    margin-bottom: 15px;
  }
`;

const StyledLine = styled.hr`
  border-top: 1px solid #d3d3d3;
  width: 100%;
  max-width: 254px;
  margin: 0px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 218px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 118px;
    margin: auto;
  }
`;


const BottomWrapperWithView = ({
  productId,
  productPrice,
  productCurrency,
  buttonText,
  buttonOnClick,
  viewButtonText,
  viewButtonOnClick,
  psaVariant
}) => (
  <BottomWrapperDiv>
    <WrapperDiv>
      <StyledLine />
      <PriceBlock>
        {formatPrice(productPrice, true, productCurrency)}
      </PriceBlock>
      <StyledLine />
    </WrapperDiv>
    <ButtonWrapper>
      <ViewButton onClick={viewButtonOnClick}>{viewButtonText}</ViewButton>
      <AddToBasketButtonWrapper>
        <AddToBasketButtonWithAjaxCall
          fupid={productId}
          quantity={1}
          full={false}
          beforeAddingToBasket={buttonOnClick}
          psaVariant={psaVariant}
          buttonPlacementID={'tradeup'}
          render={({ isLoading }) => (
            <>
              <StyledLabel isLoading={isLoading}>
                {buttonText}
              </StyledLabel>
            </>
          )}
        />
      </AddToBasketButtonWrapper>
    </ButtonWrapper>

    <CompareCheckbox
      data-component={'compare-checkbox'}
      data-productid={productId}
    />
  </BottomWrapperDiv>
);

BottomWrapperWithView.propTypes = {
  productId: PropTypes.string.isRequired,
  productPrice: PropTypes.number.isRequired,
  productCurrency: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func,
  viewButtonText: PropTypes.string.isRequired,
  viewButtonOnClick: PropTypes.func,
  psaVariant: PropTypes.string.isRequired
};

BottomWrapperWithView.defaultProps = {
  productCurrency: 'GBP',
  buttonOnClick: () => {},
  viewButtonOnClick: () => {}
};

export default BottomWrapperWithView;
